module.exports = __webpack_public_path__ + "img/pic_boy@2x.7098ff6f.png";